<template>

    <div class="shop::Habitats-Website-Modules-ShopProducts-Show-ProductVariantSelector">

        <div v-for="shopProductAttribute in shopProductAttributes">

            <div class="tw-pb-1">
                {{ shopProductAttribute.name['nl'] /** TODO Low: Make language dynamic **/ }}
            </div>

            <div class="tw-pb-4">

                <div class="tw-relative">
                    <label class="tw-w-full">
                        <select
                                class="focus:tw-bg-transparent focus:tw-ring-palette-primary focus:tw-border-palette-primary focus:tw-outline-none hover:tw-bg-gray-100
                                tw-appearance-none tw-bg-white tw-block tw-border tw-border-gray-400
                                tw-leading-tight tw-pr-8 tw-px-4 tw-py-2 tw-rounded tw-text-lg tw-w-full"
                                v-model="selectedAttributeValues[shopProductAttribute.id]">

                            <option value="">Maak een keuze..</option>

                            <option
                                    v-for="attributeValue in sortAttributeValues(shopProductAttribute.attributeValues)"
                                    :disabled="productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1">{{ attributeValue }}</option>

                        </select>
                    </label>
                    <div class="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-gray-700">
                        <svg class="tw-fill-current tw-h-4 tw-w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                        </svg>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

	// TODO Medium: Support product variants which are missing a product attribute (in comparison to others), by adding a 'fake' "Geen" attribute value?
    export default {

        props: {
            productVariants: String, // Object
            currentProductVariantId: {
                type: Number,
                required: true,
            },
            productVariantBaseUrl: {
                type: String,
                required: true,
            },

            // If present, this product should only show combinations for this store.
            storeId: Number,
        },

        data()
        {
            return {
                productVariantsLocal: JSON.parse(this.$options.propsData.productVariants),
                selectedAttributeValues: {},
            };
        },

        mounted()
        {
            this.initSelectedAttributeValues();
        },

        methods: {

            initSelectedAttributeValues()
            {
                // Get product variant.
                let productVariant = _.find(this.productVariantsLocal, { id: this.currentProductVariantId });

                // Loop product attributes.
                for(let shopProductAttribute of this.shopProductAttributes)
                {
                    // Get variant attribute.
                    let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, { shop_product_attribute_id: shopProductAttribute.id });

                    // TODO Low: Fix empty productVariantAttribute when this product variant is missing this attribute.
                    // Set value of variant attribute as selected value?
                    if(productVariantAttribute)
                        this.$set(this.selectedAttributeValues, shopProductAttribute.id, productVariantAttribute.value);
                }
            },

            sortAttributeValues(attributeValues)
            {
                return [].concat(attributeValues).sort();
            },

            filterProductVariants(skipShopProductAttribute = null)
            {
                // Get all product variants.
                let productVariants = [].concat(this.productVariantsLocal);

                // Filter on selection, but not the given product attribute.
                for(let [id, attributeValue] of Object.entries(this.selectedAttributeValues))
                {
                    // Skip due to has no filter or is given product attribute?
                    if(attributeValue === null || attributeValue === '' || (skipShopProductAttribute && skipShopProductAttribute.id == id))
                        continue;

                    // Filter out selection.
                    productVariants = _.filter(productVariants, productVariant =>
                    {
                        let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == id);

                        return productVariantAttribute && productVariantAttribute.value === attributeValue;
                    });
                }

                //
                return productVariants;
            },

            // TODO Low: Refactor to computed property so we can loose the $forceUpdate in the <select.
            // TODO Low: Optimize, refactor.
            productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute)
            {
                // Get all product variants.
                let productVariants = this.filterProductVariants(shopProductAttribute);

                // No product variants left?
                if(productVariants.length == 0)
                    return false;

                // Filter on the given value.
                productVariants = _.filter(productVariants, productVariant =>
                {
                    let productVariantAttribute = _.find(productVariant.shop_product_variant_attributes, productVariantAttribute => productVariantAttribute.shop_product_attribute_id == shopProductAttribute.id);

                    return productVariantAttribute && productVariantAttribute.value === attributeValue;
                });

                // Has product variants left?
                return productVariants.length > 0;
            },

            manageUrl()
            {
                // Abort due to no product variant selected?
                if(!this.selectedProductVariant)
                    return;

                // Construct new url.
                let newUrl = this.productVariantBaseUrl.replace(':shopProductVariantSlug', this.selectedProductVariant.slug['nl'] /** TODO Low: Make language dynamic **/);

                // Navigate due to new url?
                if (newUrl != document.location.href)
                    document.location.href = newUrl;
            }

        },

        watch: {

            'selectedProductVariant'(newVal)
            {
                // Navigate to new product variant?
                if(newVal)
                    this.manageUrl();
            },

        },

        computed: {

            shopProductAttributes()
            {
                let attributeId2attribute = {};

                // Loop product variants.
                for(let productVariant of this.productVariantsLocal)
                {
                    for(let productVariantAttribute of productVariant.shop_product_variant_attributes)
                    {
                        // Get or make existing item.
                        let existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id];

                        if(!existingItem)
                            existingItem = attributeId2attribute[productVariantAttribute.shop_product_attribute.id] = {
                                attributeValues: [],
                                ...productVariantAttribute.shop_product_attribute
                            };

                        // Skip due to value already seen?
                        if(existingItem.attributeValues.indexOf(productVariantAttribute.value) !== -1)
                            continue;

                        // Add attribute value.
                        existingItem.attributeValues.push(productVariantAttribute.value);
                    }
                }

                // Sort by attribute sequence.
                return _.sortBy(
                    Object.values(attributeId2attribute),
                    'sequence'
                );
            },

            //productVariantExistsForAttributeValue[shopProductAttribute.id].indexOf(attributeValue) === -1

            productVariantExistsForAttributeValue()
            {
                let result = {};

                // Loop product attributes.
                for(let shopProductAttribute of this.shopProductAttributes)
                {
                    let attributeValuesExists = [];

                    // Loop values.
                    for(let attributeValue of shopProductAttribute.attributeValues)
                    {
                        if(this.productVariantExistsForAttributeValueHelper(attributeValue, shopProductAttribute))
                            attributeValuesExists.push(attributeValue);
                    }

                    // Set
                    result[shopProductAttribute.id] = attributeValuesExists;
                }

                //
                return result;
            },

            selectedProductVariant()
            {
                // Get filtered product variants.
                let productVariants = this.filterProductVariants();

                // Return only the one and only one.
                return productVariants.length == 1 ? productVariants[0] : null;
            },

        },

    }

</script>

<style lang="scss">
    .shop\:\:Habitats-Website-Modules-ShopProducts-Show-ProductVariantSelector {}
</style>
